/* eslint-disable prettier/prettier */
/**
 * @author sunzhiguang
 * @date 2020/8/31
 */
import React from 'react';
import { Tag } from 'antd';
// 外部标签
export function ExternalTag() {
    return React.createElement("span", { className: 'user-tags external', style: { padding: "2px 4px", lineHeight: "12px" } }, "\u5916\u90E8");
}
// 跨平台标签
export function CrossPlatformTag() {
    return React.createElement("span", { className: 'user-tags external', style: { padding: "2px 4px", lineHeight: "12px" } }, "\u5916\u90E8");
    // return null;
    // return <Tag color="geekblue">{t('common:crossPlatform')}</Tag>;
}
// 专班标签
export function SpecialProject(_a) {
    var t = _a.t;
    return (React.createElement(Tag, { style: { color: '#1686FF' }, color: "rgba(76,124,255,0.2)" }, t('common:specialProject')));
}
// 已归档专班
export function ArchiveProject() {
    return (React.createElement(Tag, { style: { color: '#1686FF' }, color: "rgba(76,124,255,0.2)" }, "\u5DF2\u5F52\u6863"));
}
// 任务标签
export function WorkProject() {
    return (React.createElement(Tag, { style: { color: '#1686FF' }, color: "rgba(76,124,255,0.2)" }, "\u4EFB\u52A1"));
}
// 日程标签
export function ScheduleProject() {
    return (React.createElement(Tag, { style: { color: '#1686FF' }, color: "rgba(76,124,255,0.2)" }, "\u65E5\u7A0B"));
}
// 单位领导
export function UnitLeader() {
    return (React.createElement(Tag, { style: {
            color: '#1686FF',
            border: '1px solid #1686FF',
            background: 'transparent',
            display: 'block',
        }, color: "rgba(76,124,255,0.2)" }, "\u5355\u4F4D\u9886\u5BFC"));
}
// 普通管理员
export function Administrator(_a) {
    var administratorType = _a.administratorType;
    return (React.createElement(Tag, { style: {
            color: '#1686FF',
            border: '1px solid #1686FF',
            background: 'transparent',
            display: 'block',
        } }, administratorType));
}
// 标签
export function Tags(_a) {
    var item = _a.item;
    var name = item.name, color = item.color, isShow = item.isShow, label = item.label, labelEnum = item.labelEnum;
    return (isShow === '1' && (React.createElement("span", { className: 'user-tags', style: {
            color: "#" + color,
            background: "#" + color + "10",
        } }, name)));
}
// 群组标签
export function GroupTag(_a) {
    var business = _a.business, kind = _a.kind, subKind = _a.subKind, t = _a.t, ext = _a.ext;
    // if (business && business.indexOf('project') > -1 && ext) {
    //     return <ArchiveProject />;
    // }
    // if (business && business.indexOf('project') > -1) {
    //     return <SpecialProject t={t} />;
    // }
    // // 日程群
    // if (business === 'schedule') {
    //     return <ScheduleProject />;
    // }
    // // 任务群
    // if (business === 'work') {
    //     return <WorkProject />;
    // }
    if (!kind || !subKind) {
        return null;
    }
    if (kind === 1024 && subKind === 3) {
        // 跨平台群
        return null;
        // return <CrossPlatformTag  />;
    }
    else if (kind === 1024 && subKind === 6) {
        // 外部群
        return null;
        // return <ExternalTag  />;
    }
    return null;
}
// 联系人标签
export function ContactsTag(_a) {
    var userI = _a.userI, userII = _a.userII, t = _a.t;
    if (!userI || !userII) {
        return null;
    }
    if (userI.app !== userII.app) {
        return React.createElement(CrossPlatformTag, null);
    }
    else if (userI.teamId !== userII.teamId) {
        return React.createElement(ExternalTag, null);
    }
    return null;
}
//# sourceMappingURL=index.js.map